import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-4 sm:gap-4 lg:grid-cols-3"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex-1 px-8 py-2 text-lg truncate" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm transition duration-250 text-gray-900 font-poppins"
}
const _hoisted_7 = { class: "flex-shrink-0 pl-4 pr-4 flex items-start justify-start" }

import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/vue/solid';


type ContractOption = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractLengthSelector',
  props: {
    contractOptions: {},
    selected: {}
  },
  emits: ["onContractSelected"],
  setup(__props: any, { emit: __emit }) {

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');



const emit = __emit;

const activationFee = (contractOption: ContractOption, discounted: boolean): string => {
  if (discounted) {
    if (contractOption.discountedPrice === 0) {
      return 'Free Activation';
    } else {
      return `$${contractOption.discountedPrice} Activation Fee`;
    }
  }
  return `$${contractOption.price} Activation Fee`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractOptions, (contractOption) => {
          return (_openBlock(), _createElementBlock("div", {
            onClick: ($event: any) => {emit('onContractSelected', contractOption.id);},
            key: contractOption.name,
            class: _normalizeClass(["transition duration-250 group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark", [ _ctx.selected === contractOption.id ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark' : '' ]])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 flex items-start justify-between hover:bg-transparent rounded-xl truncate relative", [_ctx.selected === contractOption.id ? 'bg-transparent' : 'bg-white']])
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", {
                  class: _normalizeClass(["text-2xl leading-none transition duration-250 text-black font-poppins-bold", [_ctx.selected === contractOption.id ? 'text-white' : 'text-black']])
                }, [
                  _createTextVNode(_toDisplayString(_unref(utilityService).toTitleCase(contractOption.name)), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _cache[1] || (_cache[1] = _createTextVNode(" Contract"))
                ], 2),
                _createElementVNode("p", {
                  class: _normalizeClass(["font-poppins", ['text-sm transition duration-250', contractOption.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900']])
                }, _toDisplayString(activationFee(contractOption, false)), 3),
                (contractOption.displayDiscount)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(activationFee(contractOption, true)), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.selected !== contractOption.id)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["text-right mt-6 mr-2 w-7 h-7 text-white rounded-full border border-solid", [ _ctx.selected === contractOption.id ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]])
                    }, null, 2))
                  : _createCommentVNode("", true),
                (_ctx.selected === contractOption.id)
                  ? (_openBlock(), _createBlock(_unref(CheckCircleSolidIcon), {
                      key: 1,
                      class: "text-right pt-6 pr-2 w-8 h-8 text-white",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ], 10, _hoisted_4))
        }), 128))
      ])
    ])
  ]))
}
}

})